// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WSv7","col":"styles_col__IgL40"};